import { ECP, ECPData, ECPForm, ECPParentGroup } from "../types/ecp";
import { authFetcher } from "./../utils/auth-fetch";

const getECP = async (id: string) => {
  return await authFetcher<ECP>("GET", `ecps/${id}`);
};

const getECPs = async (params: Record<string, any> = {}) => {
  return await authFetcher<ECPData>("GET", "ecps", null, {
    ...params,
  });
};

const createECP = async (data: ECPForm) => {
  return await authFetcher<ECP>("POST", "ecps", data);
};

const updateECP = async (id: string, data: ECPForm) => {
  return await authFetcher<ECP>("PATCH", `ecps/${id}`, data);
};

const getECPByParentGroup = async (parentGroup: string) => {
  return await authFetcher<ECP[]>(
    "GET",
    `ecps/parent-group/${encodeURIComponent(parentGroup)}`,
  );
};

const getECPByShipToCustomer = async (shipToCustomer: string) => {
  return await authFetcher<ECP[]>(
    "GET",
    `ecps/ship-to-customer/${encodeURIComponent(shipToCustomer)}`,
  );
};

const addShipToCustomer = async (id: string, childECPCode: string) => {
  return await authFetcher<ECP>("POST", `ecps/${id}/ship-to`, {
    child_ecp_code: childECPCode,
  });
};

const removeShipToCustomer = async (id: string, childECPCode: string) => {
  return await authFetcher<ECP>("DELETE", `ecps/${id}/ship-to`, {
    child_ecp_code: childECPCode,
  });
};

const getECPParentGroups = async (params: Record<string, any> = {}) => {
  return await authFetcher<ECPParentGroup[]>("GET", "ecp-parent-groups", null, {
    ...params,
  });
};

const enableECP = async (id: string) => {
  return await authFetcher<any>("PATCH", `ecps/${id}/enable`);
};

const disableECP = async (id: string) => {
  return await authFetcher<any>("PATCH", `ecps/${id}/disable`);
};

export {
  addShipToCustomer,
  createECP,
  disableECP,
  enableECP,
  getECP,
  getECPByParentGroup,
  getECPByShipToCustomer,
  getECPParentGroups,
  getECPs,
  removeShipToCustomer,
  updateECP,
};
